import beneficiaryStatus from 'constants/beneficiaryStatus';
import { calculateConsolidationPercent } from 'utils/consolidationPeriods';
import { Beneficiary, StockPlan } from 'types';

export const getUnits = (beneficiary: Beneficiary): number => {
  const units = beneficiary?.isCanceled
    ? beneficiary?.finalConsolidatedUnits
    : beneficiary?.sharesCount?.future;
  return units || 0;
};

export const getStatus = (
  beneficiary: Beneficiary,
  planId: string,
  plans: StockPlan[],
  date = Date.now()
): string => {
  const plan = plans?.find((plan) => plan['_id'] === planId);

  let percent: number = 0;
  let currentStatus: string;

  if (!beneficiary?.isCanceled) {
    percent = calculateConsolidationPercent(date, beneficiary, plan) || 0;
  }

  if (beneficiary?.isPaused) {
    currentStatus = beneficiaryStatus.var.PAUSED;
    return currentStatus;
  }

  if (beneficiary?.isCanceled) {
    if (beneficiary?.cancelationOption === beneficiaryStatus.var.CONSOLIDATED) {
      currentStatus = beneficiaryStatus.var.CONSOLIDATED;
    } else {
      currentStatus = beneficiaryStatus.var.CANCELED;
    }
  } else if (percent >= 0 && percent < 100) {
    currentStatus = beneficiaryStatus.var.ACTIVE;
  } else {
    currentStatus = beneficiaryStatus.var.CONSOLIDATED;
  }

  return currentStatus;
};

export const getStatusName = (
  beneficiary: Beneficiary,
  planId: string,
  plans: StockPlan[],
  date = Date.now()
): string => {
  const plan = plans?.find((plan) => plan['_id'] === planId);

  let percent: number = 0;
  let currentStatus: string;

  if (!beneficiary?.isCanceled) {
    percent = calculateConsolidationPercent(date, beneficiary, plan) || 0;
  }

  if (beneficiary?.isPaused) {
    currentStatus = beneficiaryStatus.name.PAUSED;
    return currentStatus;
  }

  if (beneficiary?.isCanceled) {
    currentStatus = beneficiaryStatus.name.CANCELED;
  } else if (percent >= 0 && percent < 100) {
    currentStatus = beneficiaryStatus.name.ACTIVE;
  } else {
    currentStatus = beneficiaryStatus.name.CONSOLIDATED;
  }

  return currentStatus;
};
